module.exports = __webpack_public_path__ + "static/media/APP_OfficeWorm_152x174_4.f1f60a6a.png";